import * as React from 'react';
import { route } from '../../utils/route';
import { trackSignupClicked } from '../../utils/tracking';

interface FinalCTAProps {
  loginUrl: string;
  whatsappUrl: string;
  promoDiscount: number;
}

export function FinalCTA({ whatsappUrl, promoDiscount }: FinalCTAProps) {
  return (
    <section className="verdu-final-cta">
      <style>{`
        .verdu-final-cta {
          padding: 80px 24px;
          background: #1a1a1a;
          text-align: center;
        }
        .verdu-final-inner {
          max-width: 640px;
          margin: 0 auto;
        }
        .verdu-final-cta h2 {
          font-size: 28px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 12px;
        }
        .verdu-final-cta p {
          font-size: 18px;
          color: rgba(255,255,255,0.75);
          margin: 0 0 36px;
        }
        .verdu-final-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .verdu-final-promo {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-top: 20px;
          padding: 10px 20px;
          background: rgba(30, 170, 37, 0.2);
          border: 1px solid rgba(30, 170, 37, 0.5);
          border-radius: 8px;
          color: #6ee674;
          font-size: 15px;
          font-weight: 500;
        }
        .verdu-final-promo strong {
          color: #fff;
          font-weight: 700;
        }
        .verdu-final-whatsapp {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          margin-top: 16px;
          color: rgba(255,255,255,0.6);
          font-size: 14px;
          text-decoration: none;
          transition: color 0.2s;
        }
        .verdu-final-whatsapp:hover {
          color: #25d366;
          text-decoration: none;
        }
        @media (max-width: 640px) {
          .verdu-final-cta {
            padding: 60px 24px;
          }
          .verdu-final-cta h2 {
            font-size: 24px;
          }
          .verdu-final-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .verdu-final-ctas a {
            justify-content: center;
          }
          .verdu-final-promo {
            display: block;
            text-align: center;
          }
        }
      `}</style>
      <div className="verdu-final-inner">
        <h2>Dejá de pasear por el Mercado de Abasto.</h2>
        <p>Recibí la mercadería en tu local y enfocate en vender.</p>
        <div className="verdu-final-ctas">
          <a href={route('wholesale.pricing')} className="verdu-btn-primary">
            <i className="fa fa-list-alt" /> Ver Precios Mayoristas
          </a>
          <a href={route('company.create')} className="verdu-btn-secondary" onClick={() => trackSignupClicked('verdulerias', 'footer')}>
            <i className="fa fa-user-plus" /> Crear una cuenta mayorista
          </a>
        </div>
        <div className="verdu-final-promo">
          <i className="fa fa-star" /> Tu primer mes con <strong>{promoDiscount}% de descuento</strong> en todos los productos
        </div>
        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="verdu-final-whatsapp">
          <i className="fa fa-whatsapp" /> ¿Dudas? Escribinos por WhatsApp
        </a>
      </div>
    </section>
  );
}
